/* Karma Guitars · Landing de producto: barra de compra fija, flechas del carrusel, videos de YouTube y
   animaciones con el Motion del tema. No toca el formulario del tema. Si este archivo o Motion no cargan, todo el contenido
   se ve igual y la compra funciona igual. Respeta "reducir movimiento". */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); }
  }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  ready(function () {
    var root = document.querySelector('[data-kl-portada]');
    if (!root) return;

    /* ---- Barra fija: aparece cuando el boton de compra de la portada sale de pantalla ---- */
    var bar = document.querySelector('[data-kl-bar]');
    if (bar) {
      var target = root.querySelector('.product-form__buttons') || root.querySelector('.kl-buy');
      var show = function (on) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var btn = bar.querySelector('button');
        if (btn) btn.tabIndex = on ? 0 : -1;
      };
      if (target) {
        /* Con scroll (no IntersectionObserver): tambien funciona cuando la pagina salta de golpe a un ancla */
        var ticking = false;
        var check = function () {
          ticking = false;
          show(target.getBoundingClientRect().bottom < 0);
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          (window.requestAnimationFrame || window.setTimeout)(check);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        check();
      } else {
        show(true);
      }
    }

    /* ---- Carrusel "Mirala de cerca": flechas en escritorio ---- */
    all('[data-kl-carousel]').forEach(function (box) {
      var track = box.querySelector('[data-kl-track]');
      var prev = box.querySelector('[data-kl-prev]');
      var next = box.querySelector('[data-kl-next]');
      if (!track || !prev || !next) return;
      var step = function () {
        var first = track.firstElementChild;
        return first ? (first.getBoundingClientRect().width + 16) * 2 : track.clientWidth;
      };
      var update = function () {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    /* ---- Videos de YouTube: se cargan solo al tocar la miniatura ---- */
    all('[data-kl-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kl-yt');
        if (!id || btn.querySelector('iframe')) return;
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
        frame.title = btn.getAttribute('aria-label') || 'YouTube';
        frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        frame.allowFullscreen = true;
        btn.appendChild(frame);
      });
    });

    /* ---- Video de la historia: se reproduce solo (en silencio) al entrar en pantalla y se pausa al salir ---- */
    all('[data-kl-autoplay] video').forEach(function (video) {
      video.muted = true;
      if (!('IntersectionObserver' in window)) { var p0 = video.play(); if (p0 && p0.catch) p0.catch(function () {}); return; }
      var userPaused = false;
      var auto = false;
      video.addEventListener('pause', function () { if (auto) { auto = false; } else if (!video.ended) { userPaused = true; } });
      video.addEventListener('play', function () { userPaused = false; });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (userPaused) return;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!video.paused) {
            auto = true;
            video.pause();
          }
        });
      }, { threshold: 0.4 }).observe(video);
    });

    /* ---- Animaciones con Motion (la misma libreria que ya carga el tema; no se carga otra para no pisarla)": pocas, y solo en lo que aun no se ha visto ---- */
    var M = window.Motion;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!M || !M.animate || !M.inView || reduce) return;
    try {
      var ease = [0.22, 1, 0.36, 1];
      var below = function (el) { return el.getBoundingClientRect().top > window.innerHeight * 0.9; };
      all('[data-kl-rv]').forEach(function (el) {
        if (!below(el)) return;
        el.style.opacity = '0';
        M.inView(el, function () { M.animate(el, { opacity: [0, 1], y: [28, 0] }, { duration: 0.7, easing: ease, ease: ease }); }, { amount: 0.15 });
      });
      all('[data-kl-stg]').forEach(function (box) {
        if (!below(box)) return;
        var kids = Array.prototype.slice.call(box.children);
        kids.forEach(function (c) { c.style.opacity = '0'; });
        M.inView(box, function () { M.animate(kids, { opacity: [0, 1], y: [20, 0] }, { duration: 0.55, delay: M.stagger(0.07), easing: ease, ease: ease }); }, { amount: 0.15 });
      });
    } catch (e) {
      all('[data-kl-rv], [data-kl-stg] > *').forEach(function (el) { el.style.opacity = '1'; });
    }
  });
})();
